import { getTranslationForIso } from '../shared';

export const generateTranslatedOrderStatuses = (orderStatuses, iso) =>
    orderStatuses.map(o => ({
        ...o,
        translatedName: getTranslationForIso(o.name, iso),
        translatedDescription: getTranslationForIso(o.description, iso),
        translatedDictionary: getTranslationForIso(o.dictionary, iso)
    }));